import { useMutation } from "@tanstack/react-query";
import { trainingMonthlyPlanApi } from "../../../../../services/human-organization/training-course-monthly.service";

export const useCreateMTP = () => {
  return useMutation({
    mutationFn: (body: any) => {
      const request = trainingMonthlyPlanApi.toRequest(body);
      return trainingMonthlyPlanApi.create(request);
    },
  });
};
